module.exports = __webpack_public_path__ + "1a260d5054e85b1bd96dc3db4559d226.svg";